export default function CsharpSyntax() {
  return (
    <h2>Csharp Syntax</h2>
  );
}
